import React, { FC, useEffect, useMemo, useState } from 'react';
import { RelevantServicesProps, Services } from './services';
import { useServicesFilters } from '../../hooks/use-services-filters';
import { useSearchSuggestionsByTitle } from '../home-search/hooks';

interface ServicesContainerProps {
  title: string;
  element?: React.ReactNode;
  totalServices?: boolean;
}

export const ServicesContainer: FC<ServicesContainerProps> = ({
  title,
  element,
}) => {
  const {
    servicesCatalogList,
    currentPage,
    setCurrentPage,
    totalPages,
    setSearch,
    isLoading,
    isRedirectWarningModalOpen,
    toggleRedirectWarningModal,
    handleRedirectWarningModalConfirm,
    dropdownData,
    switchData,
    handleInfoClick,
    handleRequestClick,
    handleSearchClick,
    handleSearchClear,
    selectedCategory,
    categories,
    selectedDepartment,
    departments,
    filters,
    resetFilters,
    totalServices,
    selectedTag,
    setFilters,
    search,
    isTotalServicesLoading,
  } = useServicesFilters();
  const handleRemoveTag = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('tag');
    window.history.pushState({}, '', url.toString());
    setFilters((prev) => ({ ...prev, selectedTag: '' }));
  };
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const { data } = useSearchSuggestionsByTitle({
    value: debouncedSearch,
  });

  const suggestions = useMemo(() => {
    if (!data) return [];
    if (!debouncedSearch?.trim() || debouncedSearch.length < 2) return [];

    return data.map((suggestion) => ({
      label: suggestion.title,
      action: () => handleInfoClick(suggestion.slug),
    }));
  }, [data, debouncedSearch, handleInfoClick]);

  const relevantServicesProps: RelevantServicesProps = {
    services: servicesCatalogList?.map((service) => ({
      title: service.title,
      onInfoClick: () => handleInfoClick(service.slug),
      onRequestClick: () => handleRequestClick(service.link),
      isOnline: service.isOnline && !!service.link,
      isDigital: service.isDigital && !!service.link,
      category: service?.category || '',
      totalServices: service.resultTotal,
    })),
    switchData,
    setCurrentPage,
    currentPage,
    totalPages,
    setSearch,
    isLoading,
    onSearchClick: handleSearchClick,
    onSearchClear: handleSearchClear,
    dropdownData,
    title,
    element,
    totalServices,
    isRedirectWarningModalOpen,
    toggleRedirectWarningModal,
    handleRedirectWarningModalConfirm,
    selectedCategory,
    categories,
    selectedDepartment,
    departments,
    filters,
    resetFilters,
    selectedTag,
    handleRemoveTag,
    suggestions,
    isTotalServicesLoading,
  };

  return <Services {...relevantServicesProps} />;
};
